import { createBrowserRouter, Navigate } from 'react-router-dom';
import { LoginPage } from '../pages/LoginPage';
import { ChangePasswordPage } from '../pages/ChangePasswordPage';
import { DashboardPage } from '../pages/DashboardPage';
import { ActionDuePage } from '../pages/ActionDuePage';
import { BeneficiariesPage } from '../pages/BeneficiariesPage';
import { PoultryPage } from '../pages/PoultryPage';
import { MaitriPage } from '../pages/MaitriPage';
import { MelaPage } from '../pages/MelaPage';
import { AIAnalyticsPage } from '../pages/AIAnalyticsPage';
import { AIRecommendationsPage } from '../pages/AIRecommendationsPage';
import { ReportsPage } from '../pages/ReportsPage';
import { UsersPage } from '../pages/UsersPage';
import { PlaceholderPage } from '../pages/PlaceholderPage';
import { AppShell } from '../components/layout/AppShell';
import { ProtectedRoute } from '../auth/ProtectedRoute';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    path: '/change-password',
    element: (
      <ProtectedRoute>
        <ChangePasswordPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppShell />
      </ProtectedRoute>
    ),
    children: [
      { index: true,                element: <DashboardPage /> },
      { path: 'actions-due',        element: <ActionDuePage /> },
      { path: 'beneficiaries',      element: <BeneficiariesPage /> },
      { path: 'poultry',            element: <PoultryPage /> },
      { path: 'maitri',             element: <MaitriPage /> },
      { path: 'mela',               element: <MelaPage /> },
      { path: 'invest',             element: <PlaceholderPage title="Invest UP" phase="Phase 3" description="Investor onboarding, DPR submission, MoU workflow, bi-directional sync with the Invest UP portal." breadcrumbs={['Modules', 'Invest UP']} /> },
      { path: 'ai-analytics',       element: <AIAnalyticsPage /> },
      { path: 'recommendations',    element: <AIRecommendationsPage /> },
      { path: 'reports',            element: <ReportsPage /> },
      { path: 'users',              element: <UsersPage /> },
      { path: '*',                  element: <Navigate to="/" replace /> },
    ],
  },
]);
